import { OnInit } from '@angular/core';
import { uniqBy } from 'lodash';
export function ValidateAutocomplete() {
    return { required: true };
}
var HistoricComponent = /** @class */ (function () {
    function HistoricComponent() {
        this.logs = [];
        this.isOpeningMaintenanceDialog = false;
    }
    HistoricComponent.prototype.ngOnInit = function () {
        this.logs = this.logs.map(function (log) {
            if (log.rating) {
                var stars = [
                    'icon-star-outline',
                    'icon-star-outline',
                    'icon-star-outline',
                    'icon-star-outline',
                    'icon-star-outline'
                ];
                for (var i = 0; i < log.rating; i++) {
                    stars[i] = 'icon-star';
                }
                log.stars = stars;
            }
            return log;
        });
        this.logs = uniqBy(this.logs, function (log) { return log.content + log.createdAt; });
    };
    return HistoricComponent;
}());
export { HistoricComponent };
